import React, { useEffect, useState } from 'react'
import { observer } from "mobx-react-lite"
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Layout from '../layout/Layout'
import Footer from '../footer/Footer'
import { useNavigate } from '@reach/router';
import {ShareDialog, shareDialogStore} from './ShareDialog';
import Viewer from '../editor/Viewer';
import classes from './Share.module.scss'
import clsx from 'clsx';
import useWindowSize from '../../hooks/window-size';
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter';
import { loadJson } from '../editor/editorSlice'
import userStore from '../common/userStore';

import { ShareModel } from './model'
import { useDispatch } from 'react-redux';
import MoreDetail from '../pack/MoreDetail';
import ShareCard from './ShareCard';


const client = applyCaseMiddleware(axios.create());


const EditorCard = observer(({share}) => {
  const {name, bio, avatar} = share.user
  const loop = share.loop
  const pack = share.pack
  const { width } = useWindowSize()
  const dispatch = useDispatch()
  const onShare = async() => {
    shareDialogStore.showModal(loop.id, share.shareCode)
  }

  useEffect(() => {
    //console.log('client(loop.json)', loop.json)
    client(loop.json).then((rsp) => {
      //console.log('client(loop.json) rsp = ', rsp.data)
      if (rsp.status === 200 && rsp.data && rsp.data.thumbnail) {
        dispatch(loadJson(rsp.data || {}))
      }
    }).catch(e => {
      console.error(e)
    })
  }, [dispatch, loadJson, loop])

  return <div className={classes.card}>
    <div className={classes.userProfile}>
      <div className={classes.userImg}>
        <Avatar className={classes.avatar2} src={avatar}>{name && name.substr(0, 1).toUpperCase()}</Avatar>
      </div>
      <div className={classes.userDesc}>
        <div className={classes.userName}>
          {name}
        </div>
        <div className={classes.userSubName}>
          {bio}
        </div>
      </div>
    </div>
    <div className={classes.editor}>
      <Viewer name={loop.name} url={loop.url} alreadyAdd={loop.alreadyAdd} backgroundImage={width > 500 ? pack.banner : pack.cover}
          onAdd={share.onAdd} onDownload={share.onDownload} onShare={onShare} onPlay={share.onPlay} />
    </div>
  </div>
})

const PackCard = observer(({share}) => {
  const navigate = useNavigate();
  const pack = share.pack

  return <div className={clsx(classes.card, classes.packCard)}>
    <div className={classes.packImg} style={{backgroundImage: `url("${pack.cover}")`}} onClick={() => navigate(`/pack/${pack.url}`)}></div>
    <div className={classes.packDesc}>
      <div className={classes.packTitle}>{pack.title}</div>
      <div className={classes.packTags}><div className={classes.packTag}>{pack.tag}</div></div>
      <div className={classes.packContent}><MoreDetail pack={pack} /></div>
      <div className={classes.packActions}>
        <Button className={classes.packAction} variant='contained' disableElevation onClick={() => navigate(`/pack/${pack.url}`)}>Browse Pack</Button>
      </div>
      <div className={classes.packBottom}>
        <div className={classes.packBottomInfo}>{pack.grooveCount} Grooves</div>
        {pack.lickCount > 0 ? <div className={classes.packBottomInfo}>{pack.lickCount} Riffs</div> : ''}
      </div>
    </div>
  </div>
})

// const ShareCardCol = observer(({title, desc, img}) => {
//   return <div className={classes.shareIconCol}>
//     <div className={clsx(classes.shareIconColImg, img)}></div>
//     <div className={classes.shareIconColTitle}>{title}</div>
//     <div className={classes.shareIconColDesc}>{desc}</div>
//   </div>
// })

// const ShareCard = observer(({share}) => {
//   const navigate = useNavigate();

//   return <div className={clsx(classes.card, classes.shareCard)}>
//     <div className={classes.shareTitle}>Make custom loops today</div>
//     <div className={classes.shareIcons}>
//       <ShareCardCol title="Customized Loops" desc="Build customized loops based on grooves, chord changes, FX, and more in seconds." img={classes['img1']} />
//       <ShareCardCol title="Royalty free" desc="All samples downloaded are royalty free and you can keep them forever."  img={classes['img2']} />
//       <ShareCardCol title="Cancel at any time" desc="You can cancel your plan at any time. A 14-day free trial is provided before you purchase."  img={classes['img3']} />
//     </div>
//     <div className={classes.shareActions}>
//       <Button className={classes.shareStarted} variant='contained' disableElevation onClick={() => navigate('/auth/signup')}>Get started</Button>
//     </div>
//   </div>
// })


const Share = observer(({shareCode}) => {
  const [share,] = useState(() => new ShareModel())

  useEffect(() => {
    share.load(shareCode)
  }, [shareCode])

  return <Layout title={share.pack.title || ''} className={"share"}>
      <div className={classes.root}>
        {share.loading ? null : <EditorCard share={share} />}
        {share.loading ? null : <PackCard share={share} />}
        {share.loading || userStore.isLogin ? null : <ShareCard className={classes.card} />}
      </div>
      <Footer className={classes.footer} />
      <ShareDialog />
  </Layout>
})

export default Share;